import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { Configuration } from './../../config/configuration';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private configuration: Configuration
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // 在路由設定必要的權限資訊
    const { requiredPermissions } = route.data;
    const userPermissions =
      this.authenticationService.currentSystemPermissionsValue;

    if (requiredPermissions && requiredPermissions.length > 0) {
      let hasPermission = false;
      for (const requiredPermission of requiredPermissions) {
        if (
          userPermissions.some(
            (rp) =>
              rp.systemCode === requiredPermission.systemCode &&
              rp.functionCode === requiredPermission.functionCode &&
              rp.privilegeCode === requiredPermission.privilegeCode
          )
        ) {
          hasPermission = true;
          break;
        }
      }
      if (!hasPermission) {
        this.router.navigate([this.configuration.routePath.noPermission]);
      }
      return hasPermission;
    } else {
      return true;
    }
  }
}
